import { useEffect, useState } from 'react';

import { apiFetchBlob } from '@/lib/api/client';

/**
 * 서버가 스트리밍하는 사진 → 오브젝트 URL.
 *
 * <p>{@code <img src>} 에 API 주소를 바로 넣을 수 없다 — 이 앱은 Bearer 토큰이라 브라우저가
 * 이미지 요청에 인증을 싣지 않는다(쿠키가 아니다). 그래서 {@code apiFetchBlob} 으로 받아 붙인다.
 *
 * <p>바이트가 오기 전이나 실패하면 null — 그때 화면은 자리를 만들지 않는다. 깨진 이미지 아이콘이
 * 잠깐이라도 보이면 고장으로 읽힌다.
 *
 * @param path 받을 경로. null 이면 아무것도 받지 않는다(사진이 없는 현장)
 */
export function usePhotoUrl(path: string | null): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (path === null) {
      setUrl(null);
      return;
    }
    let alive = true;
    let objectUrl: string | null = null;

    apiFetchBlob(path)
      .then((blob) => {
        if (!alive) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch(() => {
        if (alive) setUrl(null);
      });

    return () => {
      alive = false;
      if (objectUrl !== null) URL.revokeObjectURL(objectUrl);
    };
  }, [path]);

  return url;
}
